<template>
  <a-card :bordered="false" :headStyle="{borderBottom:'0px',fontSize:'18px'}">
    <a-row slot="title">
      <a-col :span="24">
        <span>报表下载中心</span>
        <span class="tips">报表文件生成后仅保留7天，之后文件将会自动删除。</span>
      </a-col>
    </a-row>
    <custom-page-table
      ref="table"
      rowKey="id"
      :columns="columns"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
    >
      <div slot="action" slot-scope="data">
        <a @click="goHandleRecord(data.record)">操作记录</a>
        <span v-if="data.record.status==1">
        <a-divider type="vertical"/>
        <a @click="downloadFile(data.record)">下载文件</a>
      </span>
      </div>
    </custom-page-table>
    <a-modal title="操作记录" v-model="visible" :width="650" @cancel="handleCancel" :footer="null">
      <a-table
        rowKey="indexId"
        :columns="recordColumns"
        :dataSource="recordDataList"
        :pagination="false"
      >
      </a-table>
    </a-modal>
  </a-card>
</template>

<script>
export default {
  name: 'DownloadTable',
  data() {
    return {
      visible: false,
      queryParams: {},
      loadPromise: params => this.getListPromise(params),
      recordDataList: [],
      columns: [
        {
          title: '报表发起时间',
          dataIndex: 'createTime'
        },
        {
          title: '文件名称',
          dataIndex: 'fileName'
        },
        {
          title: '报表文件状态',
          dataIndex: 'statusText'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '200px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      recordColumns: [
        {
          title: '操作时间',
          dataIndex: 'operateTimeStr'
        },
        {
          title: '操作类型',
          dataIndex: 'typeText'
        },
        {
          title: '操作人',
          dataIndex: 'operateUser'
        }
      ]
    }
  },
  mounted() {
  },
  methods: {
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getListPromise==', params)
      return this.getHttpServices().getUserService().post('api/v2/export/center/list', params)
    },
    // 去操作记录
    goHandleRecord(data) {
      this.visible = true
      this.getHttpServices().getUserService().post('api/v2/export/center/operate/list', {
        taskId: data.id,
        limitDto: {
          pageNum: 1,
          pageSize: 100
        }
      }).then(res => {
        this.getLogUtils().logWithTag('==goHandleRecord==', res)
        res.data.forEach((item, index) => {
          this.$set(item, 'indexId', index)
        })
        this.recordDataList = res.data
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    handleCancel() {
      this.visible = false
    },
    // 下载文件
    downloadFile(data) {
      this.getLogUtils().logWithTag('editData', data)
      if (data.fileUrl) {
        this.getHttpServices().getUserService().post('api/v2/export/center/operate/save', {
          taskId: data.id
        }).then(res => {
          this.getLogUtils().logWithTag('==downloadFile==', res)
          this.$message.success('文件下载成功')
          window.open(data.fileUrl)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
      } else {
        this.$message.error('网络延迟，请稍后再试')
      }

    }
  }

}
</script>
<style scoped lang="less">
.tips {
  font-size: 14px;
  padding-left: 15px;
}
</style>